import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {AllRequestData} from '@api/common';
import {Schedule, ScheduleEndpoint} from '@api/planner';

@Injectable({providedIn: 'root'})
export class ScheduleListData extends AllRequestData<Schedule> {

  private organisationId: string | null = null;

  constructor(private endpoint: ScheduleEndpoint) {
    super();
  }

  setOrganisationId(organisationId: string): void {
    this.organisationId = organisationId;
  }

  getOrganisationId(): string | null {
    return this.organisationId;
  }

  protected getCall(): Observable<Schedule[]> {
    if (!this.organisationId) {
      return throwError(() => new Error('Organisation ID not set'));
    }
    return this.endpoint.getAll(this.organisationId);
  }
}
